export class VehicleLookupRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing vehicle lookup request");
        }
        if (!request.registrationNumber) {
            throw new Error("Missing registration number in vehicle lookup request");
        }
        if (request.mileage && !request.condition) {
            throw new Error("Missing vehicle condition for valuation in vehicle lookup request");
        }
        if (request.condition && !request.mileage) {
            throw new Error("Missing mileage for valuation in vehicle lookup request");
        }
    }
    withRegistrationNumber(registrationNumber) {
        this.properties.registrationNumber = registrationNumber;
        return this;
    }
    withMileage(mileage) {
        this.properties.mileage = mileage;
        return this;
    }
    withCondition(condition) {
        this.properties.condition = condition;
        return this;
    }
    build() {
        return this.properties;
    }
}
